import React from 'react';
import { observer } from 'mobx-react';
// import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import QrCode from '@src/components/qr';

import styles from './index.less';

const EligibilityInquiryModal = ({ store, onClose }) => {
  store.use(onClose);

  const renderQrcode = () => {
    if (store?.loading) {
      return <img className={styles.loading_img} src={require('../images/loading.gif')} alt="loading" />;
    }
    if (!store.checkPrizeUrl) return null;
    return (
      <QrCode
        value={store.checkPrizeUrl}
        renderAs="canvas"
        imageSettings={{
          src: require('./images/logo.jpg'),
          height: 25,
          width: 25,
          excavate: true
        }}
      />
    );
  };
  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={styles.content}>
        <div onClick={store.onQrcodeModalClose} className={styles.close_btn} data-name="关闭" />
        <div className={styles.qrcode_box}>{renderQrcode()}</div>
      </div>
    </ModalContainer>
  );
};

export default observer(EligibilityInquiryModal);
